import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'navigation_tree_ux-categories_menu_button-click';

/**
 * Track clicking the button that opens the categories menu
 */
export function trackNavigationTreeUxCategoriesMenuButtonClick(
  action: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { action },
  });
}
